export enum FiltersKeys {
  Type = 'type'
}
